import React from "react";
import styles from "../styles.scss";
import IconComponent from "../../../../../components/commons/IconComponent";

function UnitSelector({value, onChange}) {
    return (
        <div className={styles.select}>
            <div className={styles.current}>
                <div className={styles.title}>{units[value]}</div>
                <div className={styles.subtitle}>{value}</div>
            </div>
            <div className={styles.icon}>
                <IconComponent icon="select-unit-size"/>
            </div>
            <div className={styles.dropdown}>
                {Object.keys(units).map(unit => (
                    <div key={unit} className={styles.item} onClick={() => onChange(unit)}>{unit}</div>
                ))}
            </div>
        </div>
    );
}

const units = {
    px: "Pixel",
    in: "Inches",
    mm: "Millimeters",
    cm: "Centimeters",
};

export default UnitSelector;


// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineCustomSizeModal/components/UnitSelector.js